import './FloatingCta.scss';

import type { Post } from '@travelwin/cms/types';
import { ButtonV2, Icon, Title } from '@travelwin/core';
import { useState } from 'react';

import { ClickEventData, useAnalytics } from '@/analytics';
import { isRichTextEmpty } from '@/utils/lexicalUtilts';

import { FloatingBar } from '../FloatingBar';
import { Link } from '../Link';
import { RichText } from '../RichText';
const className = 'c-FloatingCta';

type FloatingCtaProps = {
  floatingCta: Post['floatingCta'] | null;
};

const FloatingCta = ({ floatingCta }: FloatingCtaProps) => {
  const [hideFloatingCta, setHideFloatingCta] = useState(false);
  const analyticsContext = useAnalytics();
  const {
    floatingCtaText: floatingCtaContent = null,
    showFloatingCta = false,
    floatingCtaCloseModalButton,
    buttons = {},
  } = floatingCta || {};
  const { primaryBtnUrl: buttonUrl, primaryBtnText: buttonText } = buttons;

  const trackBlogFloatingCtaBtnUrl = (buttonUrl: string) => {
    const trackingData: ClickEventData = {
      element_id: 'blog-floatingCTA-destination-url',
      element_text: buttonUrl,
    };
    analyticsContext?.trackClickAction(trackingData);
  };

  const shouldDisplayFloatingCta =
    showFloatingCta && !hideFloatingCta && !isRichTextEmpty(floatingCtaContent);

  return (
    shouldDisplayFloatingCta && (
      <FloatingBar className={className} shouldUseStickyPosition>
        {floatingCtaCloseModalButton && (
          <ButtonV2
            onClick={() => setHideFloatingCta(true)}
            className={`${className}__borderCloseModalButton`}
            icons={{
              leading: <Icon name="closeButtonIcon" />,
            }}
            variant="link"
          ></ButtonV2>
        )}
        <div className={`${className}__container`}>
          <div className={`${className}__content`}>
            <Title tag={2} level={{ sm: 5, md: 3, lg: 3 }}>
              <RichText content={floatingCtaContent} />
            </Title>
          </div>
          {buttonText && buttonUrl && (
            <div className={`${className}__button-container`}>
              <ButtonV2
                variant="primary"
                asChild
                className={`${className}__Link-button`}
              >
                {/^https?:\/\//.test(buttonUrl) ? (
                  <a
                    href={buttonUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackBlogFloatingCtaBtnUrl(buttonUrl)}
                  >
                    {buttonText}
                  </a>
                ) : (
                  <Link
                    to={buttonUrl}
                    onClick={() => {
                      trackBlogFloatingCtaBtnUrl(buttonUrl);
                    }}
                  >
                    {buttonText}
                  </Link>
                )}
              </ButtonV2>
              {floatingCtaCloseModalButton && (
                <ButtonV2
                  variant="link"
                  onClick={() => setHideFloatingCta(true)}
                  className={`${className}__inlineCloseModalButton`}
                  icons={{
                    leading: <Icon name="largeXIcon" />,
                  }}
                ></ButtonV2>
              )}
            </div>
          )}
        </div>
      </FloatingBar>
    )
  );
};

export default FloatingCta;
